// extracted by mini-css-extract-plugin
export default {"WorldCupBar_title":"worldcupbar_WorldCupBar_title__f-hqU","WorldCupBar_round":"worldcupbar_WorldCupBar_round__YyBUa"};